module.exports = __webpack_public_path__ + "static/justin.7a4e8f01.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/justin.png
// module id = ./src/media/justin.png
// module chunks = 9005229563256848000